import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import WhatsAppBot from './WhatsAppBot';

const WhatsAppBotLauncher: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300"
        aria-label="Open WhatsApp Bot"
      >
        <MessageCircle className="h-6 w-6" />
      </button>

      {/* Bot Interface */}
      <WhatsAppBot isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default WhatsAppBotLauncher;
